import { useTranslation } from 'react-i18next'
import { useMemo, useState } from 'react'

import ProductsTable from './ProductsTable'
import ProductsTotal from './ProductsTotal'
import ProductListHeader from './ProductListHeader'
import { CollapseContainer } from '../../../../../components'

const ProductListSection = ({
  products,
  productSearch,
  productSearchRef,
  onSearchChange = value => {},
  productSearchDependencies,
  productSearchAlertMsg,
  latestAddedProduct,
  boxesBreakdown = null,
  activePackageLabel = null,
  searchDisabled = false,
  acceptsUnitCode = false,
}) => {
  const { i18n } = useTranslation()

  const productsWithStock = useMemo(() => Object.values(products).filter(({ quantity }) => quantity > 0), [products])

  const pendingItemsToBeReviewed = useMemo(
    () =>
      productsWithStock.reduce((accumulator, { quantity, reviewedItemsCount }) => {
        const reviewedQuantity = reviewedItemsCount || 0
        return accumulator + (quantity - reviewedQuantity)
      }, 0),
    [productsWithStock],
  )

  const [collapseOptions, setCollapseOptions] = useState({
    collapse: false,
  })

  const handleOnSearchChange = newSearchValue => {
    setCollapseOptions({ ...collapseOptions, collapse: false })
    onSearchChange(newSearchValue)
  }

  return (
    <section className="bg-white rounded-lg">
      <CollapseContainer
        destroyOnHide={false}
        options={collapseOptions}
        onCollapsedText={i18n.t('generate_shipment.product_list.see_products')}
        onNotCollapsedText={i18n.t('generate_shipment.product_list.hide_products')}
        isTogglePositionTop={false}
        containerStyles={'bg-white rounded-lg pt-4'}
        headerStyles={'px-4 pb-4'}
        footerStyles={`px-4 py-1 ${pendingItemsToBeReviewed > 0 ? 'bg-yellow-200' : 'bg-green-50'} rounded-b-lg mt-4`}
        headerComponent={
          <ProductListHeader
            pendingItemsToBeReviewed={pendingItemsToBeReviewed}
            productSearch={productSearch}
            productSearchRef={productSearchRef}
            onSearchChange={handleOnSearchChange}
            productSearchDependencies={productSearchDependencies}
            productSearchAlertMsg={productSearchAlertMsg}
            useNewDesign={boxesBreakdown != null}
            activePackageLabel={activePackageLabel}
            searchDisabled={searchDisabled}
            acceptsUnitCode={acceptsUnitCode}
          />
        }
        footerComponent={<ProductsTotal productsWithStock={productsWithStock} pendingItemsToBeReviewed={pendingItemsToBeReviewed} />}
      >
        <div className="max-h-60 overflow-y-auto">
          <ProductsTable productsWithStock={productsWithStock} focusedProduct={latestAddedProduct} boxesBreakdown={boxesBreakdown} />
        </div>
      </CollapseContainer>
    </section>
  )
}

export default ProductListSection
